"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JWTApi = exports.JWTApiFactory = exports.JWTApiFp = exports.JWTApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * JWTApi - axios parameter creator
 * @export
 */
const JWTApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetAllValidKeys: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/jwt/validKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetCurrentKey: (...args_2) => __awaiter(this, [...args_2], void 0, function* (options = {}) {
            const localVarPath = `/jwt/publicKey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} keyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetKey: (keyId_1, ...args_3) => __awaiter(this, [keyId_1, ...args_3], void 0, function* (keyId, options = {}) {
            // verify required parameter 'keyId' is not null or undefined
            (0, common_1.assertParamExists)('jwtResourceGetKey', 'keyId', keyId);
            const localVarPath = `/jwt/publicKey/{keyId}`
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [ttl]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        jwtResourceGetLoginToken: (ttl_1, ...args_4) => __awaiter(this, [ttl_1, ...args_4], void 0, function* (ttl, options = {}) {
            const localVarPath = `/jwt/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (ttl !== undefined) {
                localVarQueryParameter['ttl'] = ttl;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} user
         * @param {number} [ttl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetOtherUserToken: (user_1, ttl_2, ...args_5) => __awaiter(this, [user_1, ttl_2, ...args_5], void 0, function* (user, ttl, options = {}) {
            // verify required parameter 'user' is not null or undefined
            (0, common_1.assertParamExists)('jwtResourceGetOtherUserToken', 'user', user);
            const localVarPath = `/jwt/adminToken/{user}`
                .replace(`{${"user"}}`, encodeURIComponent(String(user)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (ttl !== undefined) {
                localVarQueryParameter['ttl'] = ttl;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [ttl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetToken: (ttl_3, ...args_6) => __awaiter(this, [ttl_3, ...args_6], void 0, function* (ttl, options = {}) {
            const localVarPath = `/jwt/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (ttl !== undefined) {
                localVarQueryParameter['ttl'] = ttl;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [ttl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetTokenByGoogle: (ttl_4, ...args_7) => __awaiter(this, [ttl_4, ...args_7], void 0, function* (ttl, options = {}) {
            const localVarPath = `/jwt/tokenGoogle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (ttl !== undefined) {
                localVarQueryParameter['ttl'] = ttl;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.JWTApiAxiosParamCreator = JWTApiAxiosParamCreator;
/**
 * JWTApi - functional programming interface
 * @export
 */
const JWTApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.JWTApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetAllValidKeys(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.jwtResourceGetAllValidKeys(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JWTApi.jwtResourceGetAllValidKeys']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetCurrentKey(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.jwtResourceGetCurrentKey(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JWTApi.jwtResourceGetCurrentKey']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} keyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetKey(keyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.jwtResourceGetKey(keyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JWTApi.jwtResourceGetKey']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [ttl]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        jwtResourceGetLoginToken(ttl, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.jwtResourceGetLoginToken(ttl, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JWTApi.jwtResourceGetLoginToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} user
         * @param {number} [ttl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetOtherUserToken(user, ttl, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.jwtResourceGetOtherUserToken(user, ttl, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JWTApi.jwtResourceGetOtherUserToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [ttl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetToken(ttl, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.jwtResourceGetToken(ttl, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JWTApi.jwtResourceGetToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [ttl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetTokenByGoogle(ttl, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.jwtResourceGetTokenByGoogle(ttl, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JWTApi.jwtResourceGetTokenByGoogle']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.JWTApiFp = JWTApiFp;
/**
 * JWTApi - factory interface
 * @export
 */
const JWTApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.JWTApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetAllValidKeys(options) {
            return localVarFp.jwtResourceGetAllValidKeys(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetCurrentKey(options) {
            return localVarFp.jwtResourceGetCurrentKey(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {JWTApiJwtResourceGetKeyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetKey(requestParameters, options) {
            return localVarFp.jwtResourceGetKey(requestParameters.keyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {JWTApiJwtResourceGetLoginTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        jwtResourceGetLoginToken(requestParameters = {}, options) {
            return localVarFp.jwtResourceGetLoginToken(requestParameters.ttl, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {JWTApiJwtResourceGetOtherUserTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetOtherUserToken(requestParameters, options) {
            return localVarFp.jwtResourceGetOtherUserToken(requestParameters.user, requestParameters.ttl, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {JWTApiJwtResourceGetTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetToken(requestParameters = {}, options) {
            return localVarFp.jwtResourceGetToken(requestParameters.ttl, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {JWTApiJwtResourceGetTokenByGoogleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtResourceGetTokenByGoogle(requestParameters = {}, options) {
            return localVarFp.jwtResourceGetTokenByGoogle(requestParameters.ttl, options).then((request) => request(axios, basePath));
        },
    };
};
exports.JWTApiFactory = JWTApiFactory;
/**
 * JWTApi - object-oriented interface
 * @export
 * @class JWTApi
 * @extends {BaseAPI}
 */
class JWTApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWTApi
     */
    jwtResourceGetAllValidKeys(options) {
        return (0, exports.JWTApiFp)(this.configuration).jwtResourceGetAllValidKeys(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWTApi
     */
    jwtResourceGetCurrentKey(options) {
        return (0, exports.JWTApiFp)(this.configuration).jwtResourceGetCurrentKey(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {JWTApiJwtResourceGetKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWTApi
     */
    jwtResourceGetKey(requestParameters, options) {
        return (0, exports.JWTApiFp)(this.configuration).jwtResourceGetKey(requestParameters.keyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {JWTApiJwtResourceGetLoginTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof JWTApi
     */
    jwtResourceGetLoginToken(requestParameters = {}, options) {
        return (0, exports.JWTApiFp)(this.configuration).jwtResourceGetLoginToken(requestParameters.ttl, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {JWTApiJwtResourceGetOtherUserTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWTApi
     */
    jwtResourceGetOtherUserToken(requestParameters, options) {
        return (0, exports.JWTApiFp)(this.configuration).jwtResourceGetOtherUserToken(requestParameters.user, requestParameters.ttl, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {JWTApiJwtResourceGetTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWTApi
     */
    jwtResourceGetToken(requestParameters = {}, options) {
        return (0, exports.JWTApiFp)(this.configuration).jwtResourceGetToken(requestParameters.ttl, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {JWTApiJwtResourceGetTokenByGoogleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWTApi
     */
    jwtResourceGetTokenByGoogle(requestParameters = {}, options) {
        return (0, exports.JWTApiFp)(this.configuration).jwtResourceGetTokenByGoogle(requestParameters.ttl, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.JWTApi = JWTApi;
//# sourceMappingURL=jwtapi.js.map